// src/router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'

// 使用 Vue Router 插件
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Index',
        component: () => import('@/views/Index.vue')
    },
]

// 使用 Vue 2 方式创建路由
const router = new VueRouter({
    mode: 'history', // 或者 'hash'
    base: process.env.BASE_URL,
    routes
})

export default router